import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import config from '../../config';
import {
  Form,
  Input,
  notification,
  Row,
  Col,
  Button,
  Modal,
  Breadcrumb,
  Select,
  DatePicker,
  Upload,
  Tabs,
  Spin,
  message,
  Divider,
} from 'antd';
import CreatePrint from './subComponents/CreatePrint';
import XRF from './xrf_new/xrf';
import MicroMeter from './MicroMeter';
import PhotoSpectro from './PhotoSpectro';
import Glossmeter from './glossmeter/Glossmeter';
import ImgDesc from './ImgDesc';
import PhyChar from './PhyChar';
import PrintMount from './print_mount/printMount';
import BasicPhoto from './basicPhoto/BasicPhoto';
import {
  confirmationModal,
  formItemLayout,
  tailFormItemLayout,
  unexpectedError,
  beforeUpload,
  handleFileChange,
  showUploadFileList,
  formatDate,
  parseDate,
  showFilesList,
} from '../../common_functions';
import { useSelector } from 'react-redux';
import PaperGroup from './PaperGroup';
import UploadTrigger from '../../common_functions/UploadTrigger';
import UploadedCheck from '../../common_functions/UploadedCheck';

// Tabs
const PrintObject = props => {
  const updatedData = useSelector(state => state.user);
  const [title, setTitle] = useState('Create Object');
  const printFormRef = useRef(null);
  const { section, id } = useParams();
  const [TabActiveKey, setTabActiveKey] = useState('1');
  const [stampUpdated, setStampUpdated] = useState(false);
  const [collections, setCollections] = useState([]);
  const [artists, setArtists] = useState([]);
  const [allObjectData, setAllObjectData] = useState();
  const [loading, setLoading] = useState(false);
  const [sectionID, setsectionID] = useState(null);
  const [disabled, setDisabled] = useState(true);
  const [authenticityConfidence, setAuthenticityConfidence] = useState([]);
  const [supportData, setSupportData] = useState([]);
  const [microTabText, setMicroTabText] = useState('Add Micrometer');
  const [glossTabText, setGlossTabText] = useState('Add Glossmeter');
  const [locations, setLocations] = useState([]);
  const [mountingUpdate, setMountingUpdate] = useState(false);
  const [objID, setObjID] = useState(null);
  const [allPaperGroup, setAllPaperGroup] = useState([]);
  const [filesState, setFilesState] = useState({
    authenticity_file: [],
    provenance_doc: [],
  });

  let saveAndNext = '';

  // update data
  const handleStateChange = useCallback((newValue = '', tab = '', tabTitle = '', tabText = '') => {
    if (newValue) setAllObjectData(newValue);
    if (tab) setTabActiveKey(tab);
    if (tabTitle) setTitle(tabTitle);
    if (tabText === 'Edit Micrometer') {
      setMicroTabText(tabText);
    }
    if (tabText === 'Edit Glossmeter') {
      setGlossTabText(tabText);
    }
    setDisabled(false);
  }, []);
  const onRemove = file => {
    return new Promise((resolve, reject) => {
      resolve(true);
    });
  };
  useEffect(() => {}, [updatedData]);
  useEffect(() => {
    let currentTab;
    async function objectData() {
      setLoading(true);
      try {
        const { data: artistData } = await props.getItems('Artist', {
          fields: ['id', 'First_Name', 'last_name'],
          sort: '-id',
          limit: -1,
        });
        setArtists(artistData);
        //get support table data
        const { data: supData } = await props.getItems('support_table', {
          fields: ['id', 'type', 'name', 'fields'],
          limit: -1,
          filters: {
            fields: {
              _in: ['record_type', 'object_type', 'work_output', 'classification', 'catalog_level'],
            },
          },
        });
        setSupportData(supData);
        //set default values
        printFormRef?.current?.setFieldsValue({
          catalog_level: supData.find(el => el.fields === 'catalog_level')?.id || undefined,
          classification: supData.find(el => el.type === 'classification' && el.name.toLowerCase() === 'photograph')?.id || undefined,
          work_type: supData.find(el => el.fields === 'work_output' && el.name.toLowerCase() === 'positive')?.id || undefined,
          obj_type: supData.find(el => el.type === 'object type' && el.name.toLowerCase() === 'individual object')?.id || undefined,
          record_type:
            supData.find(
              el => el.type === 'record type' && (el.name.toLowerCase() === 'movable work' || el.name.toLowerCase() === 'moveable work')
            )?.id || undefined,
        });
        //get autenticity confidence
        const authenticityData = await props.getItems('authenticity_confidence', {
          fields: ['id', 'confidence', 'value'],
          sort: '-confidence',
          limit: -1,
        });
        setAuthenticityConfidence(authenticityData.data);

        // if collection object is created from particular collection
        section === 'collection' && id && printFormRef?.current?.setFieldsValue({ collections: Number(id) });

        // get collection list
        let collection_data = await props.getItems('collections', {
          fields: ['id', 'name', 'folderID'],
          sort: '-id',
          limit: -1,
          filters: {
            associated_to: {
              _in: ['print', 'both'],
            },
          },
        });
        setCollections(collection_data.data);
        let { data: paperGroups } = await props.getItems('paper_groups', {
          fields: ['id,name'],
          sort: 'name',
          limit: '-1',
        });
        setAllPaperGroup(paperGroups);
        if (section === 'edit' && id) {
          const { data } = await props.getItem('collection_obj', id, {
            fields: [
              '*',
              'authenticity_file.id',
              'authenticity_file.filename_download',
              'provenance_doc.id',
              'provenance_doc.filename_download',
              'print.*',
              'print.negative_id.c_object',
              'print.negative_id.id',
              'basic_print_report.object',
            ],
            filter: { object_type: { _eq: 'print' } },
          });
          getObjectLocationDetails(data.collections);
          data.acquisition_date = parseDate(data.acquisition_date);
          data.creator = data.creator ? Number(data.creator) : null;
          setFilesState({
            provenance_doc: showUploadFileList(data?.provenance_doc?.id, data?.provenance_doc?.filename_download),
            authenticity_file: showUploadFileList(data?.authenticity_file?.id, data?.authenticity_file?.filename_download),
          });
          data.provenance_doc = data?.provenance_doc?.id;
          data.authenticity_file = data?.authenticity_file?.id;
          setAllObjectData(data);
          setsectionID(data.id);
          setObjID(data.id);
          const printData = data.print || null;
          if (printData && printData.micrometer?.length) setMicroTabText('Edit Micrometer');
          if (printData && printData.glossmeter?.length) setGlossTabText('Edit Glossmeter');
          if (data.print) setDisabled(false);
          printFormRef?.current?.setFieldsValue(data);
          let currentTab = TabActiveKey;
          if (!data.print && localStorage.getItem('tabActive') && localStorage.getItem('tabActive') !== '1') {
            currentTab = '2';
          }
          currentTab = data.print ? localStorage.getItem('tabActive') || currentTab : currentTab;
          handleTabChange(currentTab, data);
          localStorage.removeItem('tabActive');
        } else {
          localStorage.removeItem('print_sticky_filter');
          localStorage.removeItem('sticky_current_pagination');
          localStorage.removeItem('sticky_current_tab');
        }
      } catch (error) {
        if (error?.errors?.[0]?.extensions?.code === 'FORBIDDEN') {
          backButton();
          return;
        }
        unexpectedError(error);
      } finally {
        setLoading(false);
      }
    }
    objectData();
  }, [section, id]);
  // Change Title according to active tab
  let handleTabChange = (e, objData = null) => {
    let tabActiveKey, title;
    switch (e) {
      case 'mount_condition':
        tabActiveKey = 'mount_condition';
        title = 'Mount Characteristics';
        break;
      case 'image_desc':
        tabActiveKey = 'image_desc';
        title = 'Image Description';
        break;
      case '2':
        tabActiveKey = '2';
        title = 'Print / Portfolio';
        break;
      case '3':
        setMountingUpdate(true);
        tabActiveKey = '3';
        title = 'Physical Characteristics';
        break;
      case 'xrf':
        tabActiveKey = e;
        title = 'XRF';
        break;
      case 'micrometer':
        setMountingUpdate(true);
        tabActiveKey = e;
        title = microTabText;
        break;
      case 'photospectrometer':
        tabActiveKey = e;
        title = objData?.print?.photo_spectro_meter?.length > 0 ? 'Edit Photospectrometer' : 'Add Photospectrometer';
        break;
      case 'glossmeter':
        tabActiveKey = e;
        title = glossTabText;
        break;
      case 'basic_photo':
        setStampUpdated(true);
        tabActiveKey = 'basic_photo';
        title = 'Basic Photo';
        break;
      case 'micro_photo':
        tabActiveKey = 'micro_photo';
        title = 'Micro Photo';
        break;
      case 'paper_group':
        tabActiveKey = 'paper_group';
        title = 'Paper Group';
        break;
      default:
        if (sectionID) {
          tabActiveKey = '1';
          props.history.push('/print-objects/edit/' + sectionID);
          title = 'Edit Object';
        } else {
          tabActiveKey = '1';
          title = section === 'edit' ? 'Edit Object' : 'Create Object';
        }
    }
    setTabActiveKey(tabActiveKey);
    setTitle(title);
  };

  let backButton = () => {
    setTimeout(() => {
      props.history.push('/print-objects'), 1500;
    });
  };

  const complete = async values => {
    Modal.destroyAll();
    values = { ...values, object_status: 1 };
    await onSave(values);
  };
  const incomplete = async values => {
    Modal.destroyAll();
    values = { ...values, object_status: 0 };
    await onSave(values);
  };
  let onFinish = async (values, action = null) => {
    saveAndNext = '';
    if (!!action) {
      saveAndNext = action;
    }
    await confirmationModal(values, 'Status', 'Is this record complete or incomplete?', 'Incomplete', 'Complete', complete, incomplete);
  };

  // create the collection objects
  let onSave = async values => {
    setLoading(true);
    values.acquisition_date = formatDate(values?.acquisition_date);
    const fd = new FormData();
    Object.entries(values).forEach(([key, value]) => {
      if (!!value && !!value.fileList) {
        value.fileList.length > 0 ? fd.append(key, value.fileList[0].originFileObj) : '';
      } else {
        let nVal = typeof value === 'string' ? value.trim() : value;
        fd.append(key, nVal);
      }
    });

    // save collection object
    props
      .collectionObject(fd, 'file/collection_obj', sectionID)
      .then(
        async response => {
          if (response) {
            setLoading(false);
            if (response.error) {
              Modal.warning({
                title: 'Error',
                content: response.error,
              });
            } else {
              notification['success']({
                message: 'Object saved successfully!',
                description: '',
              });
            }

            printFormRef.current.resetFields(['provenance_doc', 'authenticity_file']);
            printFormRef?.current?.setFieldsValue({
              provenance_doc: response.data.provenance_doc,
              authenticity_file: response.data.authenticity_file,
            });
            response.data['print'] = allObjectData?.print ? allObjectData.print : { id: response.data.print };
            setAllObjectData(response.data);
            setsectionID(response.data.id);
            if (saveAndNext == '') {
              setTimeout(() => props.history.push('/print-objects', 1500));
            } else if (saveAndNext == 'next') {
              setTabActiveKey('2');
              setTitle('Print / Portfolio');
            }
            if (!objID) {
              await props.updatePermissionData(response.data.id);
            }
          }
        },
        errorReponse => {
          setLoading(false);
          if (errorReponse.errors !== undefined) {
            for (var i = 0; i < errorReponse.errors.length; i++) {
              var errorObj = errorReponse.errors[i];
              var errorField = errorObj.extensions.field;
              var errorFieldMessage = errorObj.message;
              Modal.warning({
                title: 'Error',
                content: errorFieldMessage,
              });
              printFormRef.current.setFields([
                {
                  name: errorField,
                  errors: [errorFieldMessage],
                },
              ]);
              Modal.warning({
                title: 'Error',
                content: errorFieldMessage,
              });
            }
          } else {
            setLoading(false);
            Modal.warning({
              title: 'Error',
              content: 'Not Saved!!',
            });
          }
        }
      )
      .catch(error => {
        setLoading(false);
        Modal.warning({
          title: 'Error',
          content: 'Not Saved!',
        });
      });
  };
  let onFinishFailed = ({ errorFields }) => {
    printFormRef.current.scrollToField(errorFields[0].name);
  };
  const showButton = () => {
    return props.showButton(props.roleType, props.tabs_permissions.prints, objID, props.prints_negatives_obj);
  };

  const handleSaveAndNext = action => {
    // saveAndNext = action;
    printFormRef.current.validateFields().then(values => {
      onFinish(values, action);
    });
  };

  const getObjectLocationDetails = async collectionID => {
    setLocations([]);
    if (!!collectionID) {
      let { data: objectLocations } = await props.getItems('location', {
        fields: ['id', 'name'],
        sort: 'name',
        limit: -1,
        filters: { collections: { _eq: collectionID } },
      });
      setLocations(objectLocations);
    }
  };
  return (
    <Spin spinning={loading} size="large">
      <Row>
        <Col className="app-breadcrumb-col">
          <Breadcrumb separator="/" items={[{ title: "Print Objects", href: "/print-objects" }, { title: title }]} />
        </Col>
        <Col className="white-paper">
          {/* Tabs start here */}
          <Tabs defaultActiveKey={TabActiveKey} activeKey={TabActiveKey} onChange={e => handleTabChange(e, allObjectData)} items={[{
  label: section === 'edit' ? 'Edit Object' : 'Create Object',
  key: "1",
  children: <div className="artist">
                <Form encType="multipart/form-data" ref={printFormRef} layout="vertical" {...formItemLayout} onFinish={onFinish} onFinishFailed={onFinishFailed} initialValues={{
      layout: tailFormItemLayout
    }}>
                  <Form.Item name="object_type" noStyle initialValue={'print'}>
                    <Input type="hidden" />
                  </Form.Item>
                  <Row gutter={24}>
                    <Col xs={24} sm={12} md={12} lg={12}>
                      <Form.Item name="collections" label="Collection" rules={[{
            required: true,
            message: 'Collection is required!'
          }]}>
                        <Select placeholder="Select collection" optionFilterProp="children" disabled={section == 'edit' || section == 'collection'} onChange={getObjectLocationDetails}>
                          {collections.map(col => {
                return <Select.Option key={col.id} value={col.id}>{col.name}</Select.Option>;
              })}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={12}>
                      <Form.Item name="title" label="Collection title (Title per Collection Record)" rules={[{
            whitespace: true,
            required: true,
            message: 'Collection title is required!'
          }]}>
                        <Input />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col xs={24} sm={12} md={12} lg={12}>
                      <Form.Item name="acquisition" label="Collection Acquisition # / ID#" rules={[{
            whitespace: true,
            required: true,
            message: 'Collection acquisition is required!'
          }]}>
                        <Input disabled={section === 'edit'} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={12}>
                      <Form.Item name="acquisition_date" label="Collection Acquisition Date">
                        <DatePicker picker="year" />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Divider />
                  <Row gutter={24}>
                    <Col xs={24} sm={12} md={12} lg={12}>
                      <Form.Item name="provenance" label="Provenance" rules={[{
            required: true,
            message: 'Provenance is required!'
          }]}>
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={12}>
                      <Form.Item name="provenance_doc" label={<div>
                            Provenance Documentation
                            <UploadedCheck uploaded={!!allObjectData && allObjectData.provenance_doc} />
                          </div>}>
                        <Upload name="file" fileList={filesState.provenance_doc} className="create_object" accept={config.FileType.docType.toString()} beforeUpload={file => {
              return beforeUpload(file, 'docType');
            }} onRemove={onRemove} onChange={e => {
              handleFileChange(e, setFilesState, 'provenance_doc');
            }} maxCount={1} multiple={false} showUploadList={showFilesList(allObjectData?.provenance_doc, 'Provenance Documentation')}>
                          <UploadTrigger fileType="docType" />
                        </Upload>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col xs={24} sm={12} md={12} lg={12}>
                      <Form.Item name="authenticity_confidences" label="Authenticity Confidence" rules={[{
            required: true,
            message: 'Authenticity confidence is required!'
          }]}>
                        <Select showSearch allowClear placeholder="Enter authenticity confidence" optionFilterProp="children" filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}>
                          {authenticityConfidence.map(el => <Select.Option key={el.id} value={el.id}>
                              {el.confidence}
                            </Select.Option>)}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={12}>
                      <Form.Item name="authenticity_file" label={<div>
                            Authenticity Confidence Doc
                            <UploadedCheck uploaded={!!allObjectData && allObjectData.authenticity_file} />
                          </div>}>
                        <Upload name="file" fileList={filesState.authenticity_file} className="create_object" accept={config.FileType.docType.toString()} beforeUpload={file => {
              return beforeUpload(file, 'docType');
            }} onRemove={onRemove} onChange={e => {
              handleFileChange(e, setFilesState, 'authenticity_file');
            }} maxCount={1} multiple={false} showUploadList={showFilesList(allObjectData?.authenticity_file, 'Authenticity Confidence Doc')}>
                          <UploadTrigger fileType="docType" />
                        </Upload>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col xs={24} sm={12} md={12} lg={12}>
                      <Form.Item name="location" label="Object Location Detail">
                        <Select showSearch allowClear placeholder="Select object location" optionFilterProp="children" filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}>
                          {locations.map(data => {
                return <Select.Option key={data.id} value={data.id}>{data.name}</Select.Option>;
              })}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={12}>
                      <Form.Item name="recorded_size" label="Recorded Size">
                        <Input />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Divider />
                  <Row gutter={24}>
                    <Col xs={24} sm={12} md={12} lg={12}>
                      <Form.Item name="creator" label="Artist / Creator" rules={[{
            required: true,
            message: 'Artist / Creator is required!'
          }]}>
                        <Select showSearch allowClear placeholder="Select artist / creator" optionFilterProp="children" filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}>
                          {!!artists.length && artists.map(art => {
                return <Select.Option key={art.id} value={art.id}>{art.First_Name + ' ' + art.last_name}</Select.Option>;
              })}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={12}>
                      <Form.Item name="secondary_artist" label="Secondary Artist / Creator">
                        <Select showSearch allowClear placeholder="Select secondary artist / creator" optionFilterProp="children" filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}>
                          {!!artists.length && artists.map(art => {
                return <Select.Option key={art.id} value={art.id}>{art.First_Name + ' ' + art.last_name}</Select.Option>;
              })}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={12}>
                      <Form.Item name="catalog_level" label="Catalog Level" rules={[{
            required: true,
            message: 'Catalog level is required!'
          }]}>
                        <Select showSearch allowClear placeholder="Select catalog level" optionFilterProp="children" filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}>
                          {supportData.map(el => el.fields === 'catalog_level' && <Select.Option key={el.id} value={el.id}>
                                  {el.name}
                                </Select.Option>)}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={12}>
                      <Form.Item name="record_type" label="Record type" rules={[{
            required: true,
            message: 'Record type is required!'
          }]}>
                        <Select showSearch allowClear placeholder="Select record type" optionFilterProp="children" filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}>
                          {supportData.map(el => el.fields === 'record_type' && <Select.Option key={el.id} value={el.id}>
                                  {el.name}
                                </Select.Option>)}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={12}>
                      <Form.Item name="classification" label="Classification" rules={[{
            required: true,
            message: 'Classification is required!'
          }]}>
                        <Select showSearch allowClear placeholder="Select classification" optionFilterProp="children" filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}>
                          {supportData.map(el => el.type === 'classification' && <Select.Option key={el.id} value={el.id}>
                                  {el.name}
                                </Select.Option>)}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={12}>
                      <Form.Item name="obj_type" label="Object Type" rules={[{
            required: true,
            message: 'Object Type is required!'
          }]}>
                        <Select showSearch allowClear placeholder="Select object type" optionFilterProp="children" filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}>
                          {supportData.map(el => el.type === 'object type' && <Select.Option key={el.id} value={el.id}>
                                  {el.name}
                                </Select.Option>)}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={12}>
                      <Form.Item name="work_type" label="Work Type, Output" rules={[{
            required: true,
            message: 'Work type is required!'
          }]}>
                        <Select showSearch allowClear placeholder="Select work type" optionFilterProp="children" filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}>
                          {supportData.map(el => el.type === 'work type' && el.fields === 'work_output' && <Select.Option key={el.id} value={el.id}>
                                  {el.name}
                                </Select.Option>)}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={12}>
                      <Form.Item name="paper_group" label="Paper Group">
                        <Select placeholder="Select Paper Group" showSearch allowClear optionFilterProp="children" filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}>
                          {allPaperGroup.map(item => {
                return <Select.Option key={item.id} value={item.id}>
                                {item.name}
                              </Select.Option>;
              })}
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Form.Item {...tailFormItemLayout}>
                    <Button style={{
          margin: '0 8px',
          backgroundColor: 'lightgrey',
          color: '#333',
          borderColor: '#333'
        }} onClick={backButton}>
                      Back
                    </Button>
                    {showButton()}
                    {showButton() != '' ? <Button className="save-btn" type="primary" style={{
          margin: '0 8px'
        }} onClick={() => handleSaveAndNext('next')}>
                        Save and Next
                      </Button> : ''}
                  </Form.Item>
                </Form>
              </div>
}, {
  label: "Print / Portfolio",
  key: "2",
  disabled: !allObjectData,
  children: <CreatePrint objectData={allObjectData} roleType={props.roleType} user_permissions={props.user_permissions} history={props.history} onRemove={onRemove} handleFileChange={handleFileChange} onChange={handleStateChange} showButton={showButton} />
}, {
  label: "Physical Characteristics",
  key: "3",
  disabled: disabled,
  children: <PhyChar roleType={props.roleType} user_permissions={props.user_permissions} print={allObjectData?.print?.id} objectData={allObjectData} history={props.history} onRemove={onRemove} handleFileChange={handleFileChange} onChange={handleStateChange} showButton={showButton} stampChanged={setStampUpdated} mountingUpdate={setMountingUpdate} mounting={mountingUpdate} activeTab={TabActiveKey} />
}, {
  label: "XRF",
  key: "xrf",
  disabled: disabled,
  children: <XRF roleType={props.roleType} user_permissions={props.user_permissions} permissions={allObjectData?.permissions ?? ''} print={allObjectData?.print?.id} history={props.history} onChange={handleStateChange} showButton={showButton} activeTab={TabActiveKey} />
}, {
  label: microTabText,
  key: "micrometer",
  disabled: disabled,
  children: <MicroMeter roleType={props.roleType} user_permissions={props.user_permissions} permissions={allObjectData?.permissions ?? ''} print={allObjectData?.print?.id} history={props.history} onChange={handleStateChange} showButton={showButton} mountingUpdate={mountingUpdate} mountingUpdateState={setMountingUpdate} activeTab={TabActiveKey} />
}, {
  label: glossTabText,
  key: "glossmeter",
  disabled: disabled,
  children: <Glossmeter roleType={props.roleType} user_permissions={props.user_permissions} print={allObjectData?.print?.id} history={props.history} onChange={handleStateChange} showButton={showButton} activeTab={TabActiveKey} />
}, {
  label: allObjectData?.print?.photo_spectro_meter?.length > 0 ? 'Edit Photospectrometer' : 'Add Photospectrometer',
  key: "photospectrometer",
  disabled: disabled,
  children: <PhotoSpectro roleType={props.roleType} user_permissions={props.user_permissions} print={allObjectData?.print?.id} history={props.history} onChange={handleStateChange} showButton={showButton} activeTab={TabActiveKey} />
}, {
  label: "Image Description",
  key: "image_desc",
  disabled: disabled,
  children: <ImgDesc roleType={props.roleType} user_permissions={props.user_permissions} objectData={allObjectData} history={props.history} onChange={handleStateChange} showButton={showButton} activeTab={TabActiveKey} />
}, {
  label: "Mount Characteristics",
  key: "mount_condition",
  disabled: disabled,
  children: <PrintMount roleType={props.roleType} user_permissions={props.user_permissions} print={allObjectData?.print?.id} history={props.history} onChange={handleStateChange} showButton={showButton} activeTab={TabActiveKey} />
}, {
  label: "Basic Photos",
  key: "basic_photo",
  disabled: disabled,
  children: <BasicPhoto roleType={props.roleType} user_permissions={props.user_permissions} deletePermissions={props?.tabs_permissions?.prints?.delete} print={allObjectData?.print?.id} stampChanged={stampUpdated} history={props.history} onChange={handleStateChange} showButton={showButton} activeTab={TabActiveKey} />
}, {
  label: "Paper Group",
  key: "paper_group",
  disabled: !allObjectData,
  children: <PaperGroup objectData={allObjectData} roleType={props.roleType} user_permissions={props.user_permissions} history={props.history} onChange={handleStateChange} haveSavePermission={showButton() === ''} activeTab={TabActiveKey} />
}]} />
          {/* Tabs End here */}
        </Col>
      </Row>
    </Spin>
  );
};
export default PrintObject;
